//angular imports
import { ChangeDetectionStrategy, Component, computed, signal, Signal, WritableSignal } from '@angular/core';
import { UserNotificationsDialogModel } from '@app/app-common';
import { ShowPlatformDialogMessage, ClosePlatformDialogMessage } from '@app/components';
import { NotificationsStateChangedMessage } from '@app/core';
import { Messenger } from '@app/shared';

@Component({
  selector: 'notification-bell',
  standalone: false,
  templateUrl: './notification-bell.component.html',
  styleUrl: './notification-bell.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotificationBellComponent {
  private notificeationStateChanged: Signal<NotificationsStateChangedMessage>;
  public isOpen: WritableSignal<boolean> = signal<boolean>(false);

  public count = computed(() => {

    let msg = this.notificeationStateChanged();

    if(!msg) return 0;

    let notifications = msg.notificationState.notifications();
    return notifications.length;
  });

  constructor(private messenger: Messenger) {
    this.notificeationStateChanged = this.messenger.getSignal(NotificationsStateChangedMessage);

    this.messenger.subscribe(this, ShowPlatformDialogMessage,
      message => {
        this.isOpen.set(message.content instanceof UserNotificationsDialogModel);
      });

    this.messenger.subscribe(this, ClosePlatformDialogMessage,
      message => {
          this.isOpen.set(false);
    });
  }


  public toggle() {
    // Logic to open notifications can be added here
    if(!this.isOpen()) {      
      this.messenger.send(ShowPlatformDialogMessage.create(new UserNotificationsDialogModel()));
    }else{      
      this.messenger.send(new ClosePlatformDialogMessage());
    }
  }
}
